export default "__VITE_ASSET__C7Irhkj7__"